import React from 'react';
import { BaseComponent } from 'kryfe-lib';
import JudgeLimit from 'pages/newHome/components/parts/judgeLimit';
import { connect } from 'react-redux';
import ApplyFormCompIndex from './ApplyForm';
import LoanCalc from './loanCalc';
import { judgeLimit, judgeLimitPhone, saveInfo } from 'pages/newHome/actions';
import { baiduTrackEvent } from 'shared/utils/commonUtil';

import { UeAddParams } from 'shared/utils/commonUtil';

import './index.less';

class Home extends BaseComponent {
  scrollToAnchor = anchorName => {
    if (anchorName) {
      let anchorElement = document.getElementById(anchorName);
      if (anchorElement) {
        anchorElement.scrollIntoView();
      }
    }
  };

  clickBottomBarBtn() {
    this.scrollToAnchor('judgeLimit');
    baiduTrackEvent('额度评估', '点击', '底部固定栏');
  }

  componentDidMount() {
    this.props.saveInfo(UeAddParams());
  }

  render() {
    let qrCode;
    if (__DEV__) {
      qrCode = require('assets/images/logo-sm.png');
    } else {
      qrCode = require('assets/images/logo-sm.png');
    }
    return (
      <React.Fragment>
        <div className="topbar">
          <div className="inner">
            <img className="logo" src={require('assets/images/logo.png')} />
            <div className="rightItems">
              <span className="qrcode">
                <img
                  className="topbarQrcode"
                  src={require('assets/images/qrpro.png')}
                />
                <img className="qrcodeLogo" src={qrCode} />
                <span className="qrcodeText">掌上客如云APP下载</span>
              </span>
              <span className="tel">
                <span className="telTitle">服务热线:</span>
                <span className="telPhone">400-8866-815</span>
              </span>
            </div>
          </div>
        </div>

        <div className="header">
          <div className="inner">
            <div className="headerLeft">
              <img
                src={require('assets/images/banner1Text.png')}
                className="headerLeftImg"
              />
            </div>
            <div className="headerRight">
              <div className="applyForm">
                <ApplyFormCompIndex />
              </div>
            </div>
          </div>
        </div>

        <div className="products">
          <div className="inner">
            <div className="productsTitle">灵活便捷，满足多元需求</div>
            <div className="productsList">
              <div
                className="productListItem productListItemFirstRow"
                onMouseEnter={() =>
                  baiduTrackEvent('产品介绍', '移入', '开店贷')
                }
              >
                <img
                  className="productIcon"
                  src={require('assets/images/kaidiandai@3x.png')}
                />
                <div className="productDesc">开店贷</div>
              </div>
              <div
                className="productListItem productListItemFirstRow"
                onMouseEnter={() =>
                  baiduTrackEvent('产品介绍', '移入', '装修贷')
                }
              >
                <img
                  className="productIcon"
                  src={require('assets/images/zhuangxiudai@3x.png')}
                />
                <div className="productDesc">装修贷</div>
              </div>
              <div
                className="productListItem productListItemFirstRow"
                onMouseEnter={() =>
                  baiduTrackEvent('产品介绍', '移入', '周转贷')
                }
              >
                <img
                  className="productIcon"
                  src={require('assets/images/zhouzhuandai@3x.png')}
                />
                <div className="productDesc">周转贷</div>
              </div>
              <div
                className="productListItem productListItemFirstRow"
                onMouseEnter={() =>
                  baiduTrackEvent('产品介绍', '移入', '天使贷')
                }
              >
                <img
                  className="productIcon"
                  src={require('assets/images/tianshidai@3x.png')}
                />
                <div className="productDesc">天使贷</div>
              </div>
              <div
                className="productListItem productListItemBottomRow"
                onMouseEnter={() =>
                  baiduTrackEvent('产品介绍', '移入', '租金贷')
                }
              >
                <img
                  className="productIcon"
                  src={require('assets/images/kaidiandai@3x.png')}
                />
                <div className="productDesc">租金贷</div>
              </div>
              <div
                className="productListItem productListItemBottomRow"
                onMouseEnter={() =>
                  baiduTrackEvent('产品介绍', '移入', '采购贷')
                }
              >
                <img
                  className="productIcon"
                  src={require('assets/images/caigoudai@3x.png')}
                />
                <div className="productDesc">采购贷</div>
              </div>
              <div
                className="productListItem productListItemBottomRow"
                onMouseEnter={() =>
                  baiduTrackEvent('产品介绍', '移入', '蓝领贷')
                }
              >
                <img
                  className="productIcon"
                  src={require('assets/images/lanlingdai@3x.png')}
                />
                <div className="productDesc">蓝领贷</div>
              </div>
              <div className="productListItemMore productListItemBottomRow">
                <img
                  className="productIcon moreProductIcon"
                  src={require('assets/images/more@3x.png')}
                />
                <div className="productDesc">更多</div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="applySteps"
          onMouseEnter={() => baiduTrackEvent('产品介绍', '移入', '申请流程')}
        >
          <div className="applyStepsTitle">3步申请，比想象更简单</div>
          <div className="steps">
            <div className="inner">
              <div className="stepsItemShortDivider">
                <div className="divider" />
              </div>
              <div className="stepsItem">
                <img
                  className="stepsItemImg"
                  src={require('assets/images/input@3x.png')}
                />
                <div className="stepsItemDesc">评估额度</div>
              </div>
              <div className="stepsItemLongDivider">
                <div className="divider" />
              </div>
              <div className="stepsItem">
                <img
                  className="stepsItemImg"
                  src={require('assets/images/judge@3x.png')}
                />
                <div className="stepsItemDesc">填写申请</div>
              </div>
              <div className="stepsItemLongDivider">
                <div className="divider" />
              </div>
              <div className="stepsItem">
                <img
                  className="stepsItemImg"
                  src={require('assets/images/verify@3x.png')}
                />
                <div className="stepsItemDesc">验证审核</div>
              </div>
              <div className="stepsItemShortDivider">
                <div className="divider" />
              </div>
            </div>
          </div>
        </div>

        <div
          id="judgeLimit"
          className="judgeLimit"
          onMouseEnter={() => baiduTrackEvent('产品介绍', '移入', '额度评估')}
        >
          <JudgeLimit
            _judgeLimit={this.props.judgeLimit}
            _judgeLimitPhone={this.props.judgeLimitPhone}
          />
        </div>

        <div
          className="loanCalc"
          onMouseEnter={() =>
            baiduTrackEvent('贷款计算器', '移入', '贷款计算器')
          }
        >
          <LoanCalc />
        </div>

        <div className="cases">
          <div className="inner">
            <div className="casesList">
              <div className="casesListItem">
                <div className="casesListItemCover">
                  <div className="casesListItemCoverInner">
                    王先生在广州开了一家酒楼，经营状况还不错，打算开分店，由于资金周转有点困难，想申请一笔贷款。但是银行手续繁杂，申请难度大；网络贷款需要抵押房产/车子，贷款额度低。王先生听说客如云推出了金融服务，作为合作商户，需要的材料少，操作流程简单，还不需要抵押任何东西，就在掌上客如云APP上申请了，最终顺利的拿到了130万贷款。
                  </div>
                </div>
                <div className="casesListItemAvatarBox">
                  <img
                    className="casesListItemAvatar"
                    src={require('assets/images/case1_avatar@3x.png')}
                  />
                </div>
                <div className="casesListItemName">王先生</div>
                <div className="casesListItemDesc">
                  <span className="casesListItemType">开店贷款</span>
                  <span className="casesListItemAmount">130万</span>
                </div>
              </div>
              <div className="casesListItem">
                <div className="casesListItemCover">
                  <div className="casesListItemCoverInner">
                    李先生在湖北开了一家快餐店，想要装修一下店铺，但装修期间没有收入来源，资金周转比较困难。李先生看见客如云的金融广告，在网页上留了电话，当天就有金融顾问回访。经过了解，金融顾问向李先生定制了贷款产品，并详细的介绍了申请流程，李先生提交资料后，第二天就拿到了50万贷款。
                  </div>
                </div>
                <div className="casesListItemAvatarBox">
                  <img
                    className="casesListItemAvatar"
                    src={require('assets/images/case2_avatar@3x.png')}
                  />
                </div>
                <div className="casesListItemName">李先生</div>
                <div className="casesListItemDesc">
                  <span className="casesListItemType">装修贷款</span>
                  <span className="casesListItemAmount">50万</span>
                </div>
              </div>
              <div className="casesListItem">
                <div className="casesListItemCover">
                  <div className="casesListItemCoverInner">
                    张女士在成都开了一家奶茶店，开店初期知名度低，推广难度大，店铺运营面临困境，张女士想做一些推广活动，但手里资金有点紧张。张女士在掌上客如云APP上申请了“云小贷”产品，操作简单，在手机上几分钟就搞定了，当天就放款了5万元。
                  </div>
                </div>
                <div className="casesListItemAvatarBox">
                  <img
                    className="casesListItemAvatar"
                    src={require('assets/images/case3_avatar@3x.png')}
                  />
                </div>
                <div className="casesListItemName">张女士</div>
                <div className="casesListItemDesc">
                  <span className="casesListItemType">采购贷款</span>
                  <span className="casesListItemAmount">5万</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer">
          <div className="inner">
            <div className="footerQrcodeBox">
              <img
                className="footerQrcode"
                src={require('assets/images/keruyun-weixin.jpg')}
              />
              <div className="footerQrcodeText">客如云贷款公众号</div>
            </div>
            <div className="footerLinks">
              <a
                className="footerLinksItem"
                href="http://www.keruyun.com/about/intro"
              >
                公司简介
              </a>
              <span className="footerLinksItemDivider">|</span>
              <a
                className="footerLinksItem"
                href="http://www.keruyun.com/about/news"
              >
                公司动态
              </a>
              <span className="footerLinksItemDivider">|</span>
              <a
                className="footerLinksItem"
                href="http://www.keruyun.com/about/culture"
              >
                企业文化
              </a>
              <span className="footerLinksItemDivider">|</span>
              <a
                className="footerLinksItem"
                href="http://www.keruyun.com/about/history"
              >
                发展历程
              </a>
              <span className="footerLinksItemDivider">|</span>
              <a
                className="footerLinksItem"
                href="http://keruyun.zhiye.com/home"
              >
                招贤纳士
              </a>
              <span className="footerLinksItemDivider">|</span>
              <a
                className="footerLinksItem"
                href="http://www.keruyun.com/contact/branch"
              >
                和我联系
              </a>
            </div>
            <div className="contacts">
              <div className="contactsItem contactsPhone">
                <img
                  className="contactsIco"
                  src={require('assets/images/contacts-tel.png')}
                />
                <span className="contactsText">400-8866-815</span>
              </div>
              <div className="contactsItem contactsEmail">
                <img
                  className="contactsIco"
                  src={require('assets/images/contacts-mail.png')}
                />
                <span className="contactsText">kfpt-product@keruyun.com</span>
              </div>
              <div className="contactsItem contactsWorkTime">
                <img
                  className="contactsIco"
                  src={require('assets/images/contacts-worktime.png')}
                />
                <span className="contactsText">9:00-21:00</span>
              </div>
            </div>
            <div className="copyRights">
              Copyright©2012-2022shishitongyunInc.Allrightsreserved.
              京B2-20192601|京ICP备19038847号-4
            </div>
          </div>
          <div className="thirdPartLinks">
            <div className="inner">
              <a className="thirdPartLinksItem" href="https://bj.nuomi.com/">
                百度糯米
              </a>
              <a className="thirdPartLinksItem" href="http://www.meituan.com/">
                美团
              </a>
              <a className="thirdPartLinksItem" href="http://www.dianping.com/">
                大众点评
              </a>
              <a className="thirdPartLinksItem" href="https://www.ele.me/home/">
                饿了么
              </a>
              <a
                className="thirdPartLinksItem"
                href="http://waimai.meituan.com/"
              >
                美团外卖
              </a>
              <a className="thirdPartLinksItem" href="https://map.baidu.com/">
                百度地图
              </a>
              <a
                className="thirdPartLinksItem"
                href="http://www.zhongchouke.com/"
              >
                众筹客
              </a>
            </div>
          </div>
        </div>

        <div className="bottomPlaceholder" />

        <div className="bottomBar">
          <div className="inner">
            <div className="bottomBarLeft">
              <span className="bottomBarStrongText bottomBarLimitLeft">
                10亿+
              </span>
              <span className="bottomBarNormalText">贷款额度</span>
            </div>
            <div className="bottomBarMiddle">
              <div className="bottomBarStrongText">
                <span className="bottomBarMiddleLeft">0门槛</span>
                <span>无抵押</span>
              </div>
            </div>
            <div
              className="bottomBarBtn"
              onClick={this.clickBottomBarBtn.bind(this)}
            >
              测测你能贷多少
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

let mapDispatchToProps = {
  judgeLimit,
  judgeLimitPhone,
  saveInfo,
};

export default connect(null, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/pages/newHome/components/index.jsx